export const IconSizeClasses = {
  ICON_SIZE_XS: ['fa-xs'],
  ICON_SIZE_SM: ['fa-sm'],
  ICON_SIZE_LG: ['fa-lg'],
  ICON_SIZE_2X: ['fa-2x'],
  ICON_SIZE_3X: ['fa-3x'],
  ICON_SIZE_5X: ['fa-5x'],
  ICON_SIZE_7X: ['fa-7x'],
  ICON_SIZE_10X: ['fa-10x'],
}
